import { AGENTS, type Agent } from './agents';

interface AgentPickerProps {
  onSelect: (agent: Agent) => void;
}

export function AgentPicker({ onSelect }: AgentPickerProps) {
  return (
    <div className="agent-picker">
      <h3 className="agent-picker-title">Choose an agent</h3>
      <div className="agent-grid">
        {AGENTS.map((agent) => (
          <button
            key={agent.id}
            className="agent-card"
            onClick={() => onSelect(agent)}
          >
            <span className="agent-card-emoji">{agent.emoji}</span>
            <span className="agent-card-name">{agent.name}</span>
            <span className="agent-card-desc">{agent.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
